import { __awaiter } from "tslib";
import { BasketCore } from "../../core/basket";
import { BetsCartFeaturesListener } from '~/web-frontend-core/api/connector/cart/BetCartFeatures';
import { isNumber } from "~/web-frontend-core/typeGuards";
import { urlSlug } from './helpers';
import { slugify } from './helpers';
import Cookies from 'js-cookie';
import { getConfig } from '~/web-frontend-core/config';
var betType;
(function (betType) {
    betType[betType["ordinar"] = 1] = "ordinar";
    betType[betType["express"] = 2] = "express";
    betType[betType["system"] = 3] = "system";
})(betType || (betType = {}));
var agreeWithCoefChange;
(function (agreeWithCoefChange) {
    agreeWithCoefChange[agreeWithCoefChange["settingForBannedUsers"] = -1] = "settingForBannedUsers";
    agreeWithCoefChange[agreeWithCoefChange["never"] = 0] = "never";
    agreeWithCoefChange[agreeWithCoefChange["everything"] = 1] = "everything";
    agreeWithCoefChange[agreeWithCoefChange["ifRise"] = 2] = "ifRise";
})(agreeWithCoefChange || (agreeWithCoefChange = {}));
export class BasketBusiness {
    constructor(config, subscriberFn, basketApi, appName, isIrm) {
        this.subscribers = new Set();
        this.appName = '';
        this.state = {
            oddsIds: new Set(),
            odds: {},
            max: 0,
            maxExpress: 0,
            maxSystem: 0,
            config: {},
            betType: betType.ordinar,
            isVipBet: 0,
            isClearBasketAfterBet: false,
            agreeWithCoefChange: agreeWithCoefChange.never,
            activeBet: '',
            amount: null,
            isAllOddsLine: false,
            systemType: '',
            basketApi: {
                set: (betData) => {
                    return new Promise(data => data);
                }
            },
            isBetRequestLoading: false,
            isBetOneClick: false,
            globalError: '',
            expressCoef: 1,
            oneClickBetAmount: 0,
            minVipExpress: 0,
            minVipSystem: 0,
            possibleWin: 0,
            systemTypeAvailable: [],
            succesExpressAndSystemMessage: '',
            isRequestSuccess: null,
            promoId: 0,
            expressMultiplierPercents: [],
            expressInsuranceData: {
                success: false,
                message: '',
            },
            successExpressMultiplierData: {
                coeffWithMultiplier: null,
                message: '',
                multiplierPercent: null,
            },
            failedExpressMultiplierData: {
                message: '',
                oddWithLowCoeffIds: [],
            },
            isFreeBet: false,
            disableDoBetButton: false,
            min: null,
            betsCartFeatures: {
                expressInsurance: {
                    minOddsCount: null,
                    minCoeff: null,
                    minBetSum: null,
                }
            },
        };
        this.appName = appName;
        this.isIrm = isIrm;
        this.state.config = config;
        this.subscribe(subscriberFn);
        this.state.basketApi = basketApi;
    }
    initBetsCartFeaturesListener(currency) {
        const betsCartFeaturesListener = new BetsCartFeaturesListener();
        betsCartFeaturesListener.subscribe({
            currency: currency,
            onmessage: (data) => {
                this.state.betsCartFeatures = data;
                this.notify();
            },
        });
    }
    setSettings(settings) {
        this.setAgreeWithCoefChanging(settings.agreeWithCoefChange ? settings.agreeWithCoefChange : agreeWithCoefChange.never);
        this.state.isClearBasketAfterBet = settings.isClearBasketAfterBet ? settings.isClearBasketAfterBet : false;
        // this.state.oneClickBetAmount = settings.oneClickBetAmount ? settings.oneClickBetAmount : 0;
        this.notify();
    }
    setIsBetOneClick(isOneClick) {
        this.state.isBetOneClick = isOneClick;
        isOneClick && this.setBetType(betType.ordinar);
        this.notify();
    }
    setIsBetOneClickSum(amount) {
        this.state.oneClickBetAmount = amount;
    }
    setCoeffId(coeffId) {
        if (this.state.config.coeffKind === coeffId)
            return;
        this.state.config.coeffKind = coeffId;
        this.getOddData();
    }
    setIsFreeBet(isFreeBet) {
        this.state.isFreeBet = isFreeBet;
        this.notify();
    }
    getOddData() {
        const oddIds = [...this.state.oddsIds].filter(oddId => {
            return typeof oddId === 'string';
        });
        if (!oddIds.length) {
            return null;
        }
        const sendConfig = Object.assign(Object.assign({}, this.state.config), { jwt: Cookies.get('jwt'), odds: oddIds });
        return new Promise(resolve => {
            this.basketUnit = new BasketCore(sendConfig, this.isIrm);
            this.basketUnit.subscribe((data) => {
                this.prepareData.bind(this)(data);
                resolve(data);
            });
        });
    }
    subscribe(fn) {
        this.subscribers.add(fn);
    }
    notify() {
        this.subscribers.forEach((fn) => fn(this.state));
    }
    unsubscribe(fn) {
        this.subscribers.delete(fn);
    }
    addOdd(oddId, matchId) {
        if (this.state.isBetOneClick) {
            this.state.oddsIds.clear();
            this.state.oddsIds.add(oddId);
            if (getConfig('IS_MOBILE')) {
                this.setActiveBet(oddId, true);
            }
            return this.getOddData().then(() => {
                this.state.odds[oddId].amount = this.state.oneClickBetAmount;
                return this.doBetRequest().then(() => this.state.oddsIds.clear());
            });
        }
        if (this.state.oddsIds.has(oddId) && this.state.activeBet !== oddId)
            return;
        const maxOddsInBasket = 29;
        if (this.state.oddsIds.size > maxOddsInBasket) {
            // @ts-ignore
            this.setGlobalError(window.getLang('BASKET_MAX_BETS', { count: 30 }));
            this.notify();
            return;
        }
        this.state.oddsIds.forEach(oddIdInSet => {
            var _a;
            if (((_a = this.state.odds[oddIdInSet]) === null || _a === void 0 ? void 0 : _a.matchId) === matchId) {
                this.state.oddsIds.delete(oddIdInSet);
            }
        });
        this.state.oddsIds.add(oddId);
        this.getOddData();
        this.validateBetType();
        this.notify();
    }
    /** Используется для добавления событий из локалСторедж*/
    addMultiOdds(oddsIds) {
        if (!oddsIds.length)
            return;
        oddsIds.forEach(oddId => {
            if (typeof oddId === 'string') {
                this.state.oddsIds.add(oddId);
            }
        });
        this.getOddData()
            .then(() => {
            this.state.oddsIds.forEach(oddId => {
                var _a;
                if (!((_a = this.state.odds[oddId]) === null || _a === void 0 ? void 0 : _a.cf)) {
                    this.state.oddsIds.delete(oddId);
                    delete this.state.odds[oddId];
                }
            });
            this.getOddData();
        })
            .then(() => {
            this.validateBetType();
            this.notify();
        });
    }
    clearBasket() {
        this.state = {
            oddsIds: new Set(),
            odds: {},
            max: 0,
            maxExpress: 0,
            maxSystem: 0,
            config: this.state.config,
            betType: this.state.betType,
            isClearBasketAfterBet: this.state.isClearBasketAfterBet,
            agreeWithCoefChange: this.state.agreeWithCoefChange,
            isVipBet: this.state.isVipBet,
            isAllOddsLine: false,
            activeBet: '',
            amount: 0,
            systemType: '',
            basketApi: this.state.basketApi,
            isBetRequestLoading: this.state.isBetRequestLoading,
            isBetOneClick: this.state.isBetOneClick,
            globalError: '',
            expressCoef: 1,
            oneClickBetAmount: this.state.oneClickBetAmount,
            minVipExpress: 0,
            minVipSystem: 0,
            possibleWin: 0,
            systemTypeAvailable: [],
            succesExpressAndSystemMessage: '',
            isRequestSuccess: null,
            promoId: this.state.promoId,
            isFreeBet: this.state.isFreeBet,
            disableDoBetButton: false,
            min: null,
            betsCartFeatures: this.state.betsCartFeatures,
        };
        this.notify();
    }
    clearRequestResult() {
        this.state.isRequestSuccess = null;
        this.notify();
    }
    deleteOdd(id) {
        this.state.oddsIds.delete(id);
        this.getOddData();
        this.validateBetType();
        this.notify();
    }
    /** В целях экономии времени не рефакторил механизм валидации и скопировал его со старого проекта */
    onOrdinarAmountInput(amount, oddId) {
        let number = amount.replace(/[^.\d]+/g, '').replace(/^([^\.]*\.)|\./g, '$1');
        const match = number.toString().match(/(\d+\.\d{1,2})/);
        number = match ? match[0] : number;
        // this.error.status = 0;
        if (number.length > 0) {
            // @ts-ignore потому что конструктор Number() не считает точку за число
            this.state.odds[oddId].amount = number;
        }
        else {
            this.state.odds[oddId].amount = null;
        }
        this.calculatePossibleWin();
        this.notify();
    }
    onExpressOrSystemAmountInput(amount) {
        let number = amount.replace(/[^.\d]+/g, '').replace(/^([^\.]*\.)|\./g, '$1');
        const match = number.toString().match(/(\d+\.\d{1,2})/);
        number = match ? match[0] : number;
        // this.error.status = 0;
        if (number.length > 0) {
            // @ts-ignore потому что конструктор Number() не считает точку за число
            this.state.amount = number;
        }
        else {
            this.state.amount = null;
        }
        this.calculatePossibleWin();
        this.notify();
    }
    clearOddAmountValue() {
        if (this.state.betType === 1) {
            const { odds, activeBet } = this.state;
            odds[activeBet].amount = null;
        }
        else {
            this.state.amount = null;
        }
        this.notify();
    }
    setBetType(typeId) {
        if (this.state.betType === typeId)
            return;
        this.state.betType = typeId;
        this.getOddData();
        this.validateBetType();
        this.notify();
    }
    /** Используется для вывода ошибок о нехватке событий в экспрессе и системе */
    validateBetType() {
        this.setGlobalError();
        const validateExpress = this.state.betType === betType.express && this.state.oddsIds.size < 2;
        const validateSystem = (this.state.betType === betType.system) &&
            (this.state.oddsIds.size < 3 || this.state.oddsIds.size > 20);
        if (validateExpress) {
            this.setGlobalError('ERROR_COUNT_EXPRESS');
        }
        if (validateSystem) {
            this.setGlobalError(`BASKET_ERROR_SYSTEM_${this.state.oddsIds.size < 3 ? 3 : 20}`);
        }
    }
    setGlobalError(error = '') {
        this.state.globalError = error;
    }
    setIsVipBet(isVipBet) {
        if (isVipBet === undefined)
            return;
        this.state.isVipBet = isVipBet ? 1 : 0;
        this.notify();
    }
    setAgreeWithCoefChanging(agreeWithCoefChange) {
        this.state.agreeWithCoefChange = agreeWithCoefChange;
        this.notify();
    }
    setIsClearBasketAfterBet() {
        this.state.isClearBasketAfterBet = !this.state.isClearBasketAfterBet;
        this.notify();
    }
    setActiveBet(betId, dontUseRequest) {
        if (this.state.activeBet === betId)
            return;
        this.state.activeBet = betId;
        if (!dontUseRequest) {
            this.getOddData();
        }
        this.notify();
    }
    setPromoId(promoId) {
        this.state.promoId = promoId;
    }
    setMultiplierCondition(isMultiplierCondition) {
        if (this.state.config.expressMultiplier === isMultiplierCondition)
            return;
        // this.state.config.expressMultiplier = isMultiplierCondition
        // this.getOddData()
    }
    setInsuranceCondition(isInsuranceCondition) {
        if (this.state.config.expressInsurance === isInsuranceCondition)
            return;
        this.state.config.expressInsurance = isInsuranceCondition;
        this.getOddData();
    }
    setFreeBetAmount(amount) {
        if (this.state.betType === betType.ordinar
            && !this.state.isBetOneClick
            && this.state.isFreeBet
            && this.state.oddsIds.size > 1
            && !this.state.activeBet) {
            this.setGlobalError('IF_FREE_BET_ACTIVE_ONLY_ONE_BET_ACCEPTED');
            this.notify();
            return;
        }
        this.state.odds[[...this.state.oddsIds][0]].amount = amount;
        this.state.amount = amount;
        this.notify();
    }
    doBetRequest() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.state.oddsIds.size) {
                this.setGlobalError('EMPTY_INPUT');
                this.notify();
                return;
            }
            this.setGlobalError();
            const bets = {};
            let order = [];
            if (this.state.activeBet && this.state.betType === betType.ordinar) {
                const gid = this.state.activeBet;
                const oddData = this.state.odds[gid];
                if (isNumber(oddData === null || oddData === void 0 ? void 0 : oddData.matchId) && oddData) {
                    order = [oddData === null || oddData === void 0 ? void 0 : oddData.matchId];
                    bets[oddData.matchId] = {
                        gid: oddData === null || oddData === void 0 ? void 0 : oddData.matchId,
                        oddKey: gid,
                        odd: oddData === null || oddData === void 0 ? void 0 : oddData.bet,
                        cf: oddData === null || oddData === void 0 ? void 0 : oddData.cf,
                        d1: (oddData === null || oddData === void 0 ? void 0 : oddData.d1) ? oddData === null || oddData === void 0 ? void 0 : oddData.d1 : oddData === null || oddData === void 0 ? void 0 : oddData.a1,
                        d2: (oddData === null || oddData === void 0 ? void 0 : oddData.d2) ? oddData === null || oddData === void 0 ? void 0 : oddData.d2 : oddData === null || oddData === void 0 ? void 0 : oddData.a2,
                        amount: oddData === null || oddData === void 0 ? void 0 : oddData.amount,
                    };
                }
            }
            else {
                this.state.oddsIds.forEach((item) => {
                    const oddData = this.state.odds[item];
                    if (isNumber(oddData === null || oddData === void 0 ? void 0 : oddData.matchId) && oddData) {
                        order = [...order, oddData === null || oddData === void 0 ? void 0 : oddData.matchId];
                        bets[oddData.matchId] = {
                            gid: oddData === null || oddData === void 0 ? void 0 : oddData.matchId,
                            oddKey: item,
                            odd: oddData === null || oddData === void 0 ? void 0 : oddData.bet,
                            cf: oddData === null || oddData === void 0 ? void 0 : oddData.cf,
                            d1: (oddData === null || oddData === void 0 ? void 0 : oddData.d1) ? oddData === null || oddData === void 0 ? void 0 : oddData.d1 : oddData === null || oddData === void 0 ? void 0 : oddData.a1,
                            d2: (oddData === null || oddData === void 0 ? void 0 : oddData.d2) ? oddData === null || oddData === void 0 ? void 0 : oddData.d2 : oddData === null || oddData === void 0 ? void 0 : oddData.a2,
                            amount: oddData === null || oddData === void 0 ? void 0 : oddData.amount,
                        };
                    }
                });
            }
            const isVipBet = this.state.betType === betType.ordinar && getConfig('IS_MOBILE')
                ? this.state.isVipBet && !this.state.isFreeBet && ((_b = (_a = this.state.odds) === null || _a === void 0 ? void 0 : _a[this.state.activeBet]) === null || _b === void 0 ? void 0 : _b.minVip)
                : this.state.isVipBet && !this.state.isFreeBet && this.state.isAllOddsLine;
            const betData = {
                type: this.state.betType,
                amount: this.state.amount,
                odds: bets,
                // принимает только 0 | 1
                vip: Number(!!isVipBet),
                odds_order: order,
                live: this.state.isAllOddsLine ? 0 : 1,
                agree_cf: this.state.agreeWithCoefChange === agreeWithCoefChange.settingForBannedUsers ? agreeWithCoefChange.never
                    : this.state.agreeWithCoefChange,
                system_type: this.state.systemType,
                promo_id: this.state.isFreeBet ? this.state.promoId : 0,
                is_accumulator_multiplier: (this.state.config.expressMultiplier
                    && this.state.betType === betType.express && !this.state.isFreeBet && !this.state.isBetOneClick) ? 1 : 0,
                is_accumulator_insurance: (this.state.config.expressInsurance
                    && this.state.betType === betType.express && !this.state.isFreeBet && !this.state.isBetOneClick) ? 1 : 0,
            };
            this.setIsLoading(true);
            this.state.isRequestSuccess = null;
            yield this.state.basketApi.set(betData)
                .then((data) => __awaiter(this, void 0, void 0, function* () {
                if (!this.state.isBetOneClick) {
                    yield this.getOddData();
                }
                return data;
            }))
                .then(data => {
                var _a, _b;
                this.doBetRequestData = data;
                this.setIsLoading(false);
                this.state.isRequestSuccess = ((_a = data === null || data === void 0 ? void 0 : data.result) === null || _a === void 0 ? void 0 : _a.code) === 0;
                if (this.state.isRequestSuccess) {
                    if (this.state.isClearBasketAfterBet) {
                        this.clearBasket();
                    }
                    if (this.state.isFreeBet) {
                        this.setIsFreeBet(false);
                    }
                }
                this.state.isRequestSuccess = ((_b = data === null || data === void 0 ? void 0 : data.result) === null || _b === void 0 ? void 0 : _b.code) === 0;
                this.setAfterBetNotification(data);
                this.notify();
            });
        });
    }
    setAfterBetNotification(data) {
        this.state.oddsIds.forEach(oddId => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
            if (!((_b = (_a = this.state.odds) === null || _a === void 0 ? void 0 : _a[oddId]) === null || _b === void 0 ? void 0 : _b.matchId))
                return;
            this.state.odds[oddId].text = ((_g = (_d = (_c = data === null || data === void 0 ? void 0 : data.result) === null || _c === void 0 ? void 0 : _c.odds) === null || _d === void 0 ? void 0 : _d[(_f = (_e = this.state.odds) === null || _e === void 0 ? void 0 : _e[oddId]) === null || _f === void 0 ? void 0 : _f.matchId]) === null || _g === void 0 ? void 0 : _g.text) || '';
            this.state.odds[oddId].isOddSuccessRequest = ((_m = (_j = (_h = data === null || data === void 0 ? void 0 : data.result) === null || _h === void 0 ? void 0 : _h.odds) === null || _j === void 0 ? void 0 : _j[(_l = (_k = this.state.odds) === null || _k === void 0 ? void 0 : _k[oddId]) === null || _l === void 0 ? void 0 : _l.matchId]) === null || _m === void 0 ? void 0 : _m.code) === 0;
            this.state.succesExpressAndSystemMessage = ((_o = data === null || data === void 0 ? void 0 : data.result) === null || _o === void 0 ? void 0 : _o.code) === 0 ? (_p = data === null || data === void 0 ? void 0 : data.result) === null || _p === void 0 ? void 0 : _p.text : '';
            ((_q = data === null || data === void 0 ? void 0 : data.result) === null || _q === void 0 ? void 0 : _q.code) !== 0 && this.setGlobalError(((_r = data === null || data === void 0 ? void 0 : data.result) === null || _r === void 0 ? void 0 : _r.text) || (data === null || data === void 0 ? void 0 : data.text));
        });
    }
    setIsLoading(flag) {
        this.state.isBetRequestLoading = flag;
        this.notify();
    }
    calculateExpressCoef() {
        if (this.state.betType === betType.express) {
            if (this.state.oddsIds.size < 2) {
                this.state.disableDoBetButton = true;
            }
            let expressCoef = 1;
            this.state.oddsIds.forEach(oddId => {
                var _a, _b, _c, _d;
                if (!((_b = (_a = this.state.odds) === null || _a === void 0 ? void 0 : _a[oddId]) === null || _b === void 0 ? void 0 : _b.cf))
                    return;
                expressCoef *= (_d = (_c = this.state.odds) === null || _c === void 0 ? void 0 : _c[oddId]) === null || _d === void 0 ? void 0 : _d.cf;
            });
            this.state.expressCoef = +expressCoef.toFixed(2);
        }
    }
    setSystemType(type) {
        if (this.state.oddsIds.size > 2) {
            this.state.systemType = type;
            this.notify();
        }
    }
    checkSystem(n, k) {
        const cmax = {};
        // if (!this.cmax) {
        //     this.cmax = [];
        // }
        if (!cmax[k]) {
            cmax[k] = [];
        }
        if (!cmax[k][n]) {
            cmax[k][n] = Math.round(this.factorial(n) / (this.factorial(n - k) * this.factorial(k)));
        }
        return parseInt(cmax[k][n], 10);
    }
    factorial(n) {
        return n ? n * this.factorial(n - 1) : 1;
    }
    calcSystem() {
        if (this.state.betType !== betType.system)
            return;
        if (this.state.oddsIds.size < 3) {
            this.state.disableDoBetButton = true;
        }
        const count = this.state.oddsIds.size;
        // system_type_available = [],
        let options_label = '';
        let i;
        let sys_type = '';
        let sys_name = '';
        this.state.systemTypeAvailable = [];
        // this.system_type_available = {};
        if (count < 3) {
            this.setGlobalError('BASKET_ERROR_SYSTEM_3');
        }
        else if (count > 20) {
            this.setGlobalError('BASKET_ERROR_SYSTEM_20');
        }
        else {
            for (i = 2; i < count; i++) {
                const combs = this.checkSystem(count, i);
                if (combs > 1000) {
                    continue;
                }
                if (combs > 10 && combs < 20) {
                    options_label = 'SYSTEM_V5';
                }
                else {
                    switch (combs % 10) {
                        case 1: {
                            options_label = 'SYSTEM_V1';
                            break;
                        }
                        case 2:
                        case 3:
                        case 4: {
                            options_label = 'SYSTEM_V4';
                            break;
                        }
                        default: {
                            options_label = 'SYSTEM_V5';
                        }
                    }
                }
                sys_type = `S${i}n${count}`;
                // @ts-ignore
                sys_name = `${count} ${window.getLang('SYSTEM_TEMPLATE').slice(3, 5)} ${i} (${combs} ${window.getLang(options_label)})`;
                this.state.systemTypeAvailable.push({
                    type: sys_type,
                    name: sys_name,
                });
            }
            if (!this.state.systemTypeAvailable.some(el => el.type == this.state.systemType)) {
                this.setSystemType(this.state.systemTypeAvailable[0].type);
            }
        }
    }
    calculatePossibleWin() {
        var _a, _b;
        let calculatedPossibleWin = 0;
        if (this.state.betType === betType.ordinar) {
            this.state.oddsIds.forEach(oddId => {
                var _a, _b, _c;
                if (!((_a = this.state.odds[oddId]) === null || _a === void 0 ? void 0 : _a.amount))
                    return;
                calculatedPossibleWin += ((_b = this.state.odds[oddId]) === null || _b === void 0 ? void 0 : _b.amount) * ((_c = this.state.odds[oddId]) === null || _c === void 0 ? void 0 : _c.cf);
            });
        }
        if (this.state.betType === betType.express) {
            let coef = 0;
            this.state.expressCoef > 1000 ? coef = 1000 : coef = this.state.expressCoef;
            calculatedPossibleWin = this.state.amount * coef;
            if ((_b = (_a = this.state) === null || _a === void 0 ? void 0 : _a.successExpressMultiplierData) === null || _b === void 0 ? void 0 : _b.coeffWithMultiplier) {
                this.state.successExpressMultiplierData.coeffWithMultiplier > 1000 ? coef = 1000 : coef = this.state.successExpressMultiplierData.coeffWithMultiplier;
                calculatedPossibleWin = this.state.amount * coef;
            }
        }
        this.state.possibleWin = calculatedPossibleWin;
    }
    /** Эта функция мутирует получаемый объект, если понадобится иммутабельность - доработать */
    saveOrdinarAmountBeforeRequest(newOddsData) {
        this.state.oddsIds.forEach(oddId => {
            var _a, _b;
            if (!((_a = newOddsData[oddId]) === null || _a === void 0 ? void 0 : _a.cf))
                return;
            newOddsData[oddId].amount = (_b = this.state.odds[oddId]) === null || _b === void 0 ? void 0 : _b.amount;
        });
    }
    ///////////////////////////////////////////////
    ifOddIdFromWssNull(odds) {
        this.state.oddsIds.forEach(oddId => {
            var _a, _b, _c;
            if (!((_a = odds[oddId]) === null || _a === void 0 ? void 0 : _a.cf) && ((_c = (_b = this.state.odds) === null || _b === void 0 ? void 0 : _b[oddId]) === null || _c === void 0 ? void 0 : _c.cf)) {
                this.state.odds[oddId].text = 'BETTING_IS_SUSPENDED';
                this.state.odds[oddId].isOddSuccessRequest = false;
                odds[oddId] = this.state.odds[oddId];
            }
        });
        this.notify();
    }
    getOddUrl(enSport, championshipId, matchId, enChampionship, enTeam1, enTeam2, mode = 'live') {
        const isLine = mode === 'line';
        const isSeoUrl = !!(/(zenitbet|cupis|mobile_com|desktop|mobile_new)$/.test(this.appName));
        let url = `/${mode}`;
        if (enSport) {
            url += `/${slugify(isSeoUrl && enSport)}`;
        }
        const getGamePart = (gameId) => {
            const cmd = isSeoUrl && `${enTeam1}${enTeam2 ? ` - ${enTeam2}` : ''}`;
            return `/${isLine ? 'g_' : ''}${urlSlug(gameId, cmd)}`;
        };
        if (championshipId) {
            url += `/${isLine ? 'l_' : ''}${urlSlug(championshipId, isSeoUrl && enChampionship)}`;
        }
        if (matchId) {
            url += getGamePart(matchId);
        }
        return url;
    }
    createOddUrl(odds) {
        this.state.oddsIds.forEach(oddId => {
            const oddData = odds[oddId];
            if (!oddData)
                return;
            // @ts-ignore потому что подсвечивает что minVip нет в лайв событиях и проверки не срабатывают
            const type = (oddData === null || oddData === void 0 ? void 0 : oddData.minVip) ? 'line' : 'live';
            const enSport = oddData === null || oddData === void 0 ? void 0 : oddData.enSport;
            const championshipId = oddData === null || oddData === void 0 ? void 0 : oddData.championshipId;
            const matchId = oddData === null || oddData === void 0 ? void 0 : oddData.matchId;
            const enChampionship = oddData === null || oddData === void 0 ? void 0 : oddData.enChampionship;
            const enTeam1 = oddData === null || oddData === void 0 ? void 0 : oddData.enTeam1;
            const enTeam2 = oddData === null || oddData === void 0 ? void 0 : oddData.enTeam2;
            oddData.url = this.getOddUrl(enSport, championshipId, matchId, enChampionship, enTeam1, enTeam2, type);
        });
    }
    prepareData(data) {
        const { odds, maxExpress, maxSystem, max, min, minVipExpress, minVipSystem, expressInsuranceData, expressMultiplierPercents, successExpressMultiplierData, failedExpressMultiplierData, } = data;
        if (this.state.succesExpressAndSystemMessage) {
            this.state.succesExpressAndSystemMessage = '';
        }
        this.state.disableDoBetButton = false;
        this.ifOddIdFromWssNull(odds);
        this.saveOrdinarAmountBeforeRequest(odds);
        this.createOddUrl(odds);
        this.state.odds = odds;
        this.state.maxExpress = maxExpress;
        this.state.maxSystem = maxSystem;
        this.state.minVipExpress = minVipExpress;
        this.state.minVipSystem = minVipSystem;
        this.state.min = min;
        this.state.max = max;
        this.state.expressInsuranceData = expressInsuranceData;
        this.state.expressMultiplierPercents = expressMultiplierPercents;
        this.state.successExpressMultiplierData = successExpressMultiplierData;
        this.state.failedExpressMultiplierData = failedExpressMultiplierData;
        this.state.isAllOddsLine = Object.keys(odds).every(odd => { var _a; return (_a = odds === null || odds === void 0 ? void 0 : odds[odd]) === null || _a === void 0 ? void 0 : _a.minVip; }); // это почему-то нужно php
        this.calculateExpressCoef();
        this.calcSystem();
        this.calculatePossibleWin();
        if (this.state.isFreeBet) {
            this.setFreeBetAmount(this.state.amount);
        }
        this.notify();
    }
}



// WEBPACK FOOTER //
// ./src/web-frontend-core/store/business/basket/BasketBusiness.js